import gql from 'graphql-tag';
import { graphClient, graphMutation, graphQuery } from '@services/commService';

const GET_BUSINESS_UNITS_QUERY = gql`
  query GetBusinessUnits {
    allBusinessUnits {
      id
      name
      usersCount
      isTest
    }
    noBusinessUnitUsersCount
  }
`;

const CREATE_BUSINESS_UNIT_MUTATION = gql`
  mutation CreateBusinessUnit($name: String!, $isTest: Boolean!) {
    createBusinessUnit(name: $name, isTest: $isTest) {
      id
      name
    }
  }
`;

const UPDATE_BUSINESS_UNIT_MUTATION = gql`
  mutation UpdateBusinessUnit($businessUnitId: String!, $name: String!, $isTest: Boolean!) {
    updateBusinessUnit(businessUnitId: $businessUnitId, name: $name, isTest: $isTest) {
      id
      name
      isTest
    }
  }
`;

const REMOVE_BUSINESS_UNIT_MUTATION = gql`
  mutation RemoveBusinessUnit($businessUnitId: String!) {
    removeBusinessUnit(businessUnitId: $businessUnitId) {
      id
      name
    }
  }
`;

export const getBusinessUnits = async () => {
  const result = await graphQuery(GET_BUSINESS_UNITS_QUERY);
  if (!result) {
    return null;
  }

  return {
    ...result,
    errors: result.errors || [],
  };
};

export const createBusinessUnit = async (name) => {
  try {
    const result = await graphClient.mutate({
      mutation: CREATE_BUSINESS_UNIT_MUTATION,
      variables: { name, isTest: false },
      errorPolicy: 'all',
    });

    return {
      ...result,
      errors: result.errors || [],
    };
  } catch (e) {
    const fallbackMutation = `
      mutation CreateBusinessUnit($name: String!, $isTest: Boolean!) {
        createBusinessUnit(name: $name, isTest: $isTest) {
          id
          name
        }
      }
    `;
    const fallbackResult = await graphMutation(fallbackMutation, { name, isTest: false });
    if (!fallbackResult) {
      return null;
    }

    return {
      ...fallbackResult,
      errors: fallbackResult.errors || [],
    };
  }
};

export const updateBusinessUnit = async (businessUnitId, name, isTest = false) => {
  try {
    const result = await graphClient.mutate({
      mutation: UPDATE_BUSINESS_UNIT_MUTATION,
      variables: { businessUnitId, name, isTest: Boolean(isTest) },
      errorPolicy: 'all',
    });

    return {
      ...result,
      errors: result.errors || [],
    };
  } catch (e) {
    const fallbackMutation = `
      mutation UpdateBusinessUnit($businessUnitId: String!, $name: String!, $isTest: Boolean!) {
        updateBusinessUnit(businessUnitId: $businessUnitId, name: $name, isTest: $isTest) {
          id
          name
          isTest
        }
      }
    `;
    const fallbackResult = await graphMutation(fallbackMutation, { businessUnitId, name, isTest: Boolean(isTest) });
    if (!fallbackResult) {
      return null;
    }

    return {
      ...fallbackResult,
      errors: fallbackResult.errors || [],
    };
  }
};

export const removeBusinessUnit = async (businessUnitId) => {
  try {
    const result = await graphClient.mutate({
      mutation: REMOVE_BUSINESS_UNIT_MUTATION,
      variables: { businessUnitId },
      errorPolicy: 'all',
    });

    return {
      ...result,
      errors: result.errors || [],
    };
  } catch (e) {
    const fallbackMutation = `
      mutation RemoveBusinessUnit($businessUnitId: String!) {
        removeBusinessUnit(businessUnitId: $businessUnitId) {
          id
          name
        }
      }
    `;
    const fallbackResult = await graphMutation(fallbackMutation, { businessUnitId });
    if (!fallbackResult) {
      return null;
    }

    return {
      ...fallbackResult,
      errors: fallbackResult.errors || [],
    };
  }
};
